import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useMessageQualityReview } from "./ExpertMessageQualityReviewHook";
// Set the default state values for each context
export const ExpertMessageQualityReviewContext = /*#__PURE__*/createContext({});
export const ExpertMessageQualityReviewContextProvider = ({
  children
}) => {
  const hook = useMessageQualityReview();
  const {
    stateTracker
  } = useDevLogging();
  const qualityReviewMessage = useMemo(() => {
    stateTracker.trackState({
      ...hook
    });
    return {
      ...hook
    };
  }, [hook]);
  return /*#__PURE__*/React.createElement(ExpertMessageQualityReviewContext.Provider, {
    value: qualityReviewMessage
  }, children);
};
export const useExpertMessageQualityReviewContext = () => {
  return useContext(ExpertMessageQualityReviewContext);
};
ExpertMessageQualityReviewContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};